import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./mocks";

import { Provider } from "react-redux";
import { store, persistedStore } from "./redux/store/index";
import { PersistGate } from "redux-persist/integration/react";
import axios from "axios";

let ISDEV = true;
let DEV_URL = "https://prod.haelf.com/";
let LOCAL_URL = "http://localhost:5000/";

axios.defaults.baseURL = ISDEV ? DEV_URL : LOCAL_URL;

// axios.defaults.baseURL = "https://prod.haelf.com/api";
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistedStore}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
